if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.quickAddButtonWrapper = this.querySelector(".product_card_quick_add_to_cart");
      this.quickAddButton = this.querySelector(".product_card_quick_add_button");
      this.quickAddFormWrapper = this.querySelector(".product_card_quick_add_form_wrapper");
      this.pairedProducts = this.querySelector(".product_card_associated_products");
    }

    /**
     * @description Called when the element is added to the DOM
     */
    connectedCallback() {
      // Stop propagation du click sur le bouton
      if (this.quickAddButtonWrapper) {
        this.quickAddButtonWrapper.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      }

      // Stop propagation du click sur le wrapper
      if (this.quickAddFormWrapper) {
        this.quickAddFormWrapper.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      }

      // Stop propagation du click sur les produits associés
      if (this.pairedProducts) {
        this.pairedProducts.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      }

      // Gestion de l'ouverture/fermeture du formulaire
      if (this.quickAddButton) {
        this.quickAddButton.addEventListener("click", (e) => {
          e.stopPropagation();

          // Si il y en a un autre ouvert, on le ferme
          const productCardQuickAddFormWrappers = document.querySelectorAll(".product_card_quick_add_form_wrapper.open");
          productCardQuickAddFormWrappers.forEach((productCardQuickAddFormWrapper) => {
            productCardQuickAddFormWrapper.classList.remove("open");
          });

          // Sinon, on l'ouvre
          this.quickAddFormWrapper.classList.toggle("open");
        });
      }
      // Adaptation automatique de la couleur du badge selon la luminosité de l'image
      this.adaptBadgeColor();
    }

    /**
     * @description Analyse la luminosité de l'image et adapte la couleur du badge
     */
    async adaptBadgeColor() {
      const badge = this.querySelector(".product_card_badge");
      const image = this.querySelector(".product_card_image img");

      if (!badge || !image) return;

      if (badge.classList.contains("percentage_badges")) {
        return;
      }

      try {
        // Attendre que l'image soit chargée
        if (!image.complete) {
          await new Promise((resolve) => {
            image.onload = resolve;
            image.onerror = resolve;
          });
        }

        // Analyser la luminosité de l'image
        const brightness = await this.getImageBrightness(image);

        // Adapter la couleur du badge
        if (brightness > 0.5) {
          // Image claire -> texte sombre
          badge.style.color = "#000000";
          // badge.style.textShadow = "0 0 3px rgba(255, 255, 255, 0.8)";
        } else {
          // Image sombre -> texte clair
          badge.style.color = "#ffffff";
          // badge.style.textShadow = "0 0 3px rgba(0, 0, 0, 0.8)";
        }
      } catch (error) {
        console.warn("Erreur lors de l'analyse de l'image:", error);
        // Fallback : garder la couleur par défaut
        badge.style.color = "#ffffff";
      }
    }

    /**
     * @description Calcule la luminosité moyenne d'une image
     * @param {HTMLImageElement} img - L'élément image à analyser
     * @returns {Promise<number>} - Luminosité entre 0 (sombre) et 1 (clair)
     */
    getImageBrightness(img) {
      return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Redimensionner l'image pour l'analyse (performance)
        const sampleSize = 50;
        canvas.width = sampleSize;
        canvas.height = sampleSize;

        // Dessiner l'image redimensionnée
        ctx.drawImage(img, 0, 0, sampleSize, sampleSize);

        // Récupérer les données des pixels
        const imageData = ctx.getImageData(0, 0, sampleSize, sampleSize);
        const data = imageData.data;

        let totalBrightness = 0;
        const pixelCount = data.length / 4; // 4 valeurs par pixel (RGBA)

        // Calculer la luminosité moyenne
        for (let i = 0; i < data.length; i += 4) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];

          // Formule de luminosité relative (pondérée)
          const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
          totalBrightness += brightness;
        }

        const averageBrightness = totalBrightness / pixelCount;
        resolve(averageBrightness);
      });
    }
  }

  customElements.define("product-card", ProductCard);
}

if (!customElements.get("quick-add-form")) {
  class QuickAddForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.cart = document.querySelector("cart-drawer");
      this.submitButton = this.querySelector("[type='submit']");

      if (this.cart) this.submitButton.setAttribute("aria-haspopup", "dialog");
      this.hideErrors = this.dataset.hideErrors === "true";
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      this.handleErrorMessage();

      this.submitButton.setAttribute("aria-disabled", true);
      this.submitButton.classList.add("loading");
      // this.querySelector(".loading__spinner").classList.remove("hidden");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          "sections",
          this.cart.sections_to_render().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        // this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          // En cas d'erreur
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButtonText.classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = false;
          this.cart.render_contents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          //this.querySelector(".loading__spinner").classList.add("hidden");
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product_form_error_wrapper");
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product_form_error_message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define("quick-add-form", QuickAddForm);
}

window.addEventListener("DOMContentLoaded", () => {
  // Si on clique n'importe ou sur la page, sauf sur un .un .product_card_quick_add_form_wrapper, est qu'on à un open, on le ferme
  document.addEventListener("click", (e) => {
    if (e.target.closest(".product_card_quick_add_form_wrapper")) return;
    const productCardQuickAddFormWrappers = document.querySelectorAll(".product_card_quick_add_form_wrapper");
    productCardQuickAddFormWrappers.forEach((productCardQuickAddFormWrapper) => {
      productCardQuickAddFormWrapper.classList.remove("open");
    });
  });
});
